export default "__VITE_ASSET___Rxv$ABj__"